import React from 'react';
import { useTranslation } from 'react-i18next';
import CurrencyFormat from '../other/CurrencyFormat';

// Prva kolona u joker-summary-row (pre Deal/Super/Premium) - obican target/promet, NIJE deo
// specijalne (JOKER) ponude, zato ima sopstvenu (svetlo ljubicastu, #E4D8F3) pozadinu bez ikonice
// i bez progress bara - vizuelno odvojen od ostale tri kartice iako deli isti oblik/velicinu.
// Isti podaci koji su ranije prikazivani u starom (uklonjenom) "loyaty-holder-info-user-box" bloku.
const LoyaltyTargetSummaryCard = ({ loyaltySettings }) => {
    const { t } = useTranslation('loyalty');
    return (
        <div className="joker-summary-card joker-summary-card-target">
            <div className="joker-target-title">{t('vasTarget')}</div>
            <div className="joker-target-stats">
                <div className="joker-target-stat">
                    <div className="joker-target-label">{t('targetZaTekuciMesec')}</div>
                    <div className="joker-target-value">
                        <CurrencyFormat num={loyaltySettings.anCompanyTarget} /> <small>{t('EUR')}</small>
                    </div>
                </div>
                <div className="joker-target-stat">
                    <div className="joker-target-label">{t('prometUTekucemMesecu')}</div>
                    <div className="joker-target-value">
                        <CurrencyFormat num={loyaltySettings.anCompanyTargetAchieved} /> <small>{t('EUR')}</small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoyaltyTargetSummaryCard;
